// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq-module__faq___2MO-d","q":"Faq-module__q___dNXqP","a":"Faq-module__a___2i04a"};